import React, { Component } from "react";
//import "../login/style.scss";
import { Cookies } from "react-cookie";
import { Redirect, Link } from "react-router-dom";
import { observer } from "mobx-react";
import UserStore from "../../stores/UserStore";
import Inner from "../template/Inner";
import AppStore from "../../stores/AppStore";
import api from "../../lib/api";
import Spinner from "react-spinkit";

@observer
class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logout: false,
      key: null,
      error: false,
      brokerage_name: "",
      dmca_link: ""
    };
  }

  componentDidMount() {
    this.load();
  }

  load() {
    this.setState({
      brokerage_name: AppStore.app_data.brokerage_name,
      dmca_link: AppStore.app_data.links.dmca
    });

    api.getAPIKey(
      response => {
        this.setState({ key: response.key });
      },
      error => {
        this.setState({ error: true });
      }
    );
  }

  copyToClipboard = e => {
    this.copyLink.select();
    document.execCommand("copy");
    window.showToastMessage("Success", "API key copied to clipboard");
    //alert("Copied to clipboard");
    // This is just personal preference.
    // I prefer to not show the the whole text area selected.
    //e.target.focus();
    //this.setState({ copySuccess: 'Copied!' });
  };

  updateBrokerageName() {
    api.updateApp(
      {
        brokerage_name: this.state.brokerage_name
      },
      response => {
        AppStore.app_data.brokerage_name = this.state.brokerage_name;
        window.showToastMessage("Success", "Name updated");
      },
      error => {
        alert("An error occured");
      }
    );
  }

  updateDMCA() {
    api.updateApp(
      {
        dmca_link: this.state.dmca_link
      },
      response => {
        AppStore.app_data.links.dmca = this.state.dmca_link;
        window.showToastMessage("Success", "DMCA link updated");
      },
      error => {
        alert("An error occured");
      }
    );
  }

  render() {
    if (!UserStore.isAdmin()) {
      return <Redirect to="/" />;
    }

    if (this.state.error) {
      return (
        <Inner>
          <div class="content">
            <div className="centerBox">
              <img src="https://bk.homestack.com/assets/img/not-found.svg" />
              <h2>Unable to load data</h2>
              <p>
                <button
                  onClick={() => {
                    this.setState({ error: false });
                    this.load();
                  }}
                >
                  Try again
                </button>
              </p>
            </div>
          </div>
        </Inner>
      );
    }

    if (!this.state.key) {
      return (
        <Inner>
          <div
            class="d-flex w-100 justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <div class="spinner-border text-warning" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </Inner>
      );
    }

    return (
      <Inner>
        <div class="bg-dark bg-dots m-b-30">
          <div class="container">
            <div class="row p-b-60 p-t-60">
              <div class="col-lg-8 text-center mx-auto text-white p-b-30">
                <div class="m-b-10">
                  <div class="avatar avatar-lg ">
                    <div class="avatar-title bg-info rounded-circle mdi mdi-settings " />
                  </div>
                </div>
                <h3>Settings &amp; Integrations</h3>
              </div>
            </div>
          </div>
        </div>

        <section class="pull-up">
          <div class="container">
            <div class="row ">
              <div class="col-lg-6">
                <div class="card py-3 m-b-30">
                  <div class="card-body">
                    <h3 class="">Brokerage / company name</h3>

                    <p>
                      If you enter something here it will show underneath each
                      agents name in the app (only for build versions 500+).
                    </p>

                    <div class="form-group">
                      <label for="api_key">Brokerage / company name</label>
                      <input
                        style={{ fontSize: 16 }}
                        id="api_key"
                        type="text"
                        class="form-control"
                        type="text"
                        onChange={e => {
                          this.setState({
                            brokerage_name: e.target.value
                          });
                        }}
                        value={this.state.brokerage_name}
                      />
                    </div>

                    <div class="text-right">
                      <button
                        onClick={() => {
                          this.updateBrokerageName();
                        }}
                        class="btn btn-primary btn-cta"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card py-3 m-b-30">
                  <div class="card-body">
                    <h3 class="">DMCA link</h3>

                    <p>
                      If you have a DMCA page, then enter here and it will be
                      linked under the listing disclaimer.
                    </p>

                    <div class="form-group">
                      <label for="dmca_link">DMCA link URL</label>
                      <input
                        style={{ fontSize: 16 }}
                        id="dmca_link"
                        type="text"
                        class="form-control"
                        type="text"
                        onChange={e => {
                          this.setState({
                            dmca_link: e.target.value
                          });
                        }}
                        value={this.state.dmca_link}
                      />
                    </div>

                    <div class="text-right">
                      <button
                        onClick={() => {
                          this.updateDMCA();
                        }}
                        class="btn btn-primary btn-cta"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="card py-3 m-b-30">
                  <div class="card-body">
                    <h3 class="">API key</h3>

                    <div class="card-body">
                      <div
                        class="alert alert-border-warning  alert-dismissible fade show"
                        role="alert"
                      >
                        <div class="d-flex">
                          <div class="icon">
                            <i class="icon mdi mdi-alert-circle-outline" />
                          </div>
                          <div class="content">
                            <strong>Keep the API key safe</strong>
                            <br />
                            This key allows access via SSO.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="api_key">Your API key</label>
                      <input
                        style={{ fontFamily: "monospace", fontSize: 16 }}
                        id="api_key"
                        type="text"
                        class="form-control"
                        ref={input => (this.copyLink = input)}
                        type="text"
                        value={this.state.key}
                      />
                    </div>

                    <div class="text-center">
                      <button
                        onClick={this.copyToClipboard}
                        class="btn btn-info btn-cta"
                      >
                        Copy API key
                      </button>

                      <hr />

                      <p>
                        Read the{" "}
                        <Link to="/settings/sso" class="text-underline">
                          SSO guide
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="card py-3 m-b-30">
                  <div class="card-body">
                    <h3 class="">
                      Zapier <span class="badge badge-warning">beta</span>
                    </h3>

                    <div class="card-body">
                      <p>
                        You can get access to the HomeStack Zapier beta from:{" "}
                        <a
                          href="https://zapier.com/developer/public-invite/28937/ce9d7c0cead1b4ca460d46d7fd1c9b7b/"
                          target="_blank"
                          class="text-underline"
                        >
                          https://zapier.com/developer/public-invite/28937/ce9d7c0cead1b4ca460d46d7fd1c9b7b
                        </a>
                      </p>

                      <hr />

                      <p>
                        Read the{" "}
                        <a
                          class="text-underline"
                          href="/assets/docs/homestack-zapier-beta-guide.pdf"
                          target="_blank"
                        >
                          Zapier integration guide
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Inner>
    );

    return (
      <Inner>
        <div class="content">
          <div class="row">
            <div class="col-2">
              {UserStore.isAgent() && (
                <div class="content-block">
                  <h2>API key</h2>
                  <p>Your unique app API key. Keep this safe!</p>
                  <p>
                    <input
                      ref={input => (this.copyLink = input)}
                      type="text"
                      value={this.state.key}
                    />
                  </p>
                  <div class="row">
                    <p>
                      <button onClick={this.copyToClipboard}>
                        Copy API key
                      </button>
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/*<div class="col-2">
              <div class="content-block">
                <h2>Regenerate API key</h2>
                <p>
                  You can generate a new API key here, but anything relying on
                  the old one will no longer work.
                </p>
                <div class="row">
                  <div class="col-lg-6">
                    <p>
                      <button
                        style={{ backgroundColor: "#a90000" }}
                        onClick={() => {
                          if (
                            window.confirm(
                              "Are you sure you want to generate a new API key? Anything using the old key will no longer work until updated."
                            )
                          ) {
                            alert("rolling....");
                          }
                        }}
                      >
                        Regenerate API key
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>*/}
          </div>
        </div>
      </Inner>
    );
  }
}

export default Settings;
